module.exports = __webpack_public_path__ + "img/Foodpanda.2a2db627.png";